/**
 * Shared policy-form constants used by both the classic Clients-tab form
 * (FIGInsured.js) and the cockpit-styled Dashboard editor (CockpitPolicyEditor.js).
 *
 * Keeping these in one module so the two form shells stay in lockstep on
 * field definitions, status values, and default field shape.
 */

export const POLICY_LOB_OPTIONS = [
  '', 'Commercial General Liability', 'Commercial Property', 'Commercial Inland Marine',
  'Commercial Auto', 'Umbrella', 'Workers Compensation', 'Crime',
  'Boiler and Machinery', 'Cyber and Privacy', 'Employment Practices Liability',
  'Professional Liability', 'Equipment Breakdown', 'Excess Liability', 'Garage',
];

export const POLICY_STATUS_OPTIONS = [
  '', 'Quote', 'Bound', 'Active', 'Cancelled', 'Terminated', 'Expired',
];

export const INVOICE_FEES_OPTIONS = ['', 'Separate', 'Combined'];

export const emptyPolicy = {
  LOB: '', Carrier: '', NAICCode: '', PolicyNumber: '', ReferenceNumber: '',
  QuoteNumber: '', EffectiveDate: '', ExpirationDate: '', Premium: '',
  Status: '', Layer: '', AdmittedStatus: '', AgencyBilled: false,
  BrokerContact: '', ProgramName: '', ProgramCode: '',
  Underwriter: '', UnderwriterOffice: '',
  StateTax: '', StampingFee: '', InspectionFee: '', BrokerFee: '', PolicyFee: '', AgencyFee: '',
  AgencyFeePercent: 4, CommissionPercent: 10, CommissionAmount: '',
  WholesaleBroker: '', InvoiceFeesDisplay: '',
  AgencyOfRecord: '', LossRunSourceId: '',
  CancellationEffectiveDate: '', CancellationReason: '',
};
